import { memo } from 'react'
import PersonalSkeleton from 'containers/PersonalSkeleton'
import CategoryLayout from 'components/Layout/Category'
import PageLayout from 'components/Layout/Page'
import Grid from '@material-ui/core/Grid'
import useMediaQuery from '@material-ui/core/useMediaQuery'
import { useTheme } from '@material-ui/core/styles'
import ProgressIndicatorSkeleton from 'components/ProgressIndicator/Skeleton'
import ReturningVisitorSkeleton from 'components/ReturningVisitor/ReturningVisitorSkeleton'
import ButtonSkeleton from './ButtonSkeleton'

const GeneralSkeleton = () => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('xs'))

  return (
    <PageLayout>
      <CategoryLayout>
        <ProgressIndicatorSkeleton />
        <ReturningVisitorSkeleton />
        <PersonalSkeleton />
        <Grid
          container
          spacing={1}
          direction={isMobile ? 'column-reverse' : 'row'}
        >
          <Grid item xs={isMobile ? 12 : 4}>
            <ButtonSkeleton />
          </Grid>
          <Grid item xs={isMobile ? 12 : 8}>
            <ButtonSkeleton />
          </Grid>
        </Grid>
      </CategoryLayout>
    </PageLayout>
  )
}

export default memo(GeneralSkeleton)
